export { OfferModel } from "./offers.model";
export { OffersService } from "./offers.service";
